import IItemOrderStatusViewModel from "interfaces/IItemOrderStatusViewModel";

const RecipientTemplate = ({ recipient }: IItemOrderStatusViewModel): any => (
  <>
    <span className="fw-bold">{recipient}</span>
  </>
);
export default RecipientTemplate;
